import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

import Api from "../../../shared/api/api";
import BlogPreview from "../components/blog/BlogPreview";
import "../styles/BlogPage.css";

export default function BlogPage() {
  const navigate = useNavigate();

  const [blogs, setBlogs] = useState([]);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    let isMounted = true;

    async function fetchBlogs() {
      try {
        setStatus("loading");

        const response = await Api.getAllAuthor("blog");

        if (!isMounted) return;

        const blogRecords = Array.isArray(response)
          ? response
          : response?.blogs || response?.data || [];

        setBlogs(Array.isArray(blogRecords) ? blogRecords : []);
        setStatus("success");
      } catch (error) {
        if (!isMounted) return;

        console.error("Error loading blogs:", error);
        setStatus("error");
      }
    }

    fetchBlogs();

    return () => {
      isMounted = false;
    };
  }, []);

  const sortedBlogs = useMemo(() => {
    return [...blogs].sort((firstBlog, secondBlog) => {
      const firstDate = new Date(firstBlog?.date || 0).getTime();
      const secondDate = new Date(secondBlog?.date || 0).getTime();

      return secondDate - firstDate;
    });
  }, [blogs]);

  function handleBlogClick(blog) {
    if (!blog?.title) return;

    navigate(`/blog/${encodeURIComponent(blog.title)}`);
  }

  return (
    <main className="blogPageContainer">
      <h1>Blog</h1>

      {status === "loading" && (
        <p className="loadingMsg" role="status">
          Loading blog posts...
        </p>
      )}

      {status === "error" && (
        <p className="warningError" role="alert">
          Blog posts could not be loaded. Please try again later.
        </p>
      )}

      {status === "success" && sortedBlogs.length === 0 && (
        <p className="blogEmptyMessage">
          No blog posts are currently available.
        </p>
      )}

      {status === "success" && sortedBlogs.length > 0 && (
        <section className="blogsGrid" aria-label="Blog posts">
          {sortedBlogs.map((blog) => {
            const blogKey =
              blog.id ||
              blog._id ||
              `${blog.title || "untitled"}-${blog.date || "undated"}`;

            return (
              <BlogPreview
                key={blogKey}
                blog={blog}
                onClick={() => handleBlogClick(blog)}
              />
            );
          })}
        </section>
      )}
    </main>
  );
}